export type {
  MapDetailsProps,
  MapDetailsSocialLink,
  WorkTimeListItem,
} from "./map-details";
export { MapDetails } from "./map-details";
